import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeFaveCustom } from '../CollectionPanel/redux/actionCreators';
import { getFaveCount, getIsFaveLoading, getIsFavourite } from '../CollectionPanel/redux/selectors';
import { getDeviationResourceType } from '../DeviationViews/_helpers';
export function useFaveButton(deviation, notificationQueue = 'default') {
    var _deviation_author;
    const isFavourite = useSelector((state)=>getIsFavourite(state, deviation));
    const isLoading = useSelector((state)=>getIsFaveLoading(state, deviation));
    const faveCount = useSelector((state)=>getFaveCount(state, deviation));
    const dispatch = useDispatch();
    var _deviation_author_useridUuid;
    const biData = BiData({
        evid: isFavourite ? 109 : 102,
        typeid: getDeviationResourceType(deviation),
        creatorid: (_deviation_author_useridUuid = (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.useridUuid) !== null && _deviation_author_useridUuid !== void 0 ? _deviation_author_useridUuid : '',
        itemid: deviation.deviationId,
        sectionname: BiContextProvidedValue,
        sectionid: BiContextProvidedValue,
        section_typeid: BiContextProvidedValue,
        sectiontype: BiContextProvidedValue,
        sectionrank: BiContextProvidedValue,
        rank: BiContextProvidedValue,
        sort_type: BiContextProvidedValue,
        reason_shown: BiContextProvidedValue,
        widgetname: BiContextProvidedValue
    });
    const onClick = useCallback(()=>dispatch(changeFaveCustom(deviation, !isFavourite, notificationQueue)), [
        deviation,
        dispatch,
        isFavourite,
        notificationQueue
    ]);
    return {
        isFavourite,
        faveCount,
        isLoading,
        biData,
        onClick
    };
}

//# sourceMappingURL=useFaveButton.js.map